import React from 'react';
import react from 'react';
import Message from 'rc-message';
import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import Permissions from 'react-redux-permissions';

// ------------
import { getOne, deleteOne } from 'api/facilityemissionApi';
import DisplayField from 'components/elements/display-field';
import { COLOR, DATETIME_FORMAT, DATE_FORMAT } from 'config';
import slug from 'constants/slug';
import Confirm from 'components/elements/confirm-element';
import Clearfix from 'components/elements/clearfix';
import PageLockHOC from 'hoc/pageLock';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;
@PageLockHOC(['facilityEmission.view'])
@connect(
  (state) => ({
    menuSelected_2: state.menu.menuSelected_2,
    focusFacility: state.menu.focusFacility,
  }),
  {}
)
class FacilitypemissionView extends React.Component {
  state = {
    _idObject: '',
    isLoaded: false,
    isLoading: false,
    facility: {},
    facilityId: '',
    initialValue: null,
    isEdit: true,
  };

  getInitialValue = (keyPath, defaultValue = '', type = 'string') => {
    // return _.result(this.state.initialValue, keyPath, defaultValue);
    const value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value) {
      return '';
    }
    switch (type) {
      case 'date':
      case 'date_1':
        return moment(value).format(
          type === 'date_1' ? DATETIME_FORMAT : DATE_FORMAT
        );
      case 'dates':
        return `${moment(value[0]).format(DATE_FORMAT)} - ${moment(
          value[1]
        ).format(DATE_FORMAT)}`;
      default:
        return value;
    }
  };

  getInitialDateValue = (keyPath, defaultValue = '') => {
    let value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value) return '';
    return moment(value).format(DATETIME_FORMAT);
  };

  async checkValidate() {
    const arr = _.split(_.result(this.props, 'match.params._id'), '-', 2);
    const _id = arr[0];
    const isEdit = arr[1] === 'false' ? false : true;
    if (_id) {
      const res = await getOne(_id);
      if (res.success && res.data) {
        this.setState({
          isEdit: isEdit,
          _idObject: res.data._id,
          facility: res.data.facility,
          facilityId: res.data.facility._id,
          isLoading: false,
          isLoaded: true,
          initialValue: res.data,
        });
      }
    } else {
      this.props.history.push(slug.FACILITY_EMISSTION.LIST);
    }
  }

  handelDelete = () => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      const emissionType = this.getInitialValue('emissionType.Name');
      this.ConfirmElm.showConfirm({
        content: (
          <div>
            {`Bạn có muốn xoá loại chất thải: `} <b>{emissionType}</b>
          </div>
        ),
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(this.getInitialValue('_id'));
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              if (this.props.menuSelected_2) {
                this.props.history.push(
                  `${slug.CO_SO.VIEW_WITH_ID}${this.props.focusFacility}`
                );
              } else {
                this.props.history.push(slug.FACILITY_EMISSTION.LIST);
              }
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };

  async componentWillMount() {
    await this.checkValidate();
  }

  render() {
    return (
      <div style={{ width: '100%' }}>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Quản lý ô nhiễm
        </h4>
        <HeaderContainer>
          <div style={{ display: 'inline-flex' }}>
            {/* <Link to={slug.FACILITY_EMISSTION.LIST}> */}
            <Icon
              onClick={() => {
                if (this.props.menuSelected_2) {
                  this.props.history.push(
                    `${slug.CO_SO.VIEW_WITH_ID}${this.props.focusFacility}`
                  );
                } else {
                  this.props.history.push(slug.FACILITY_EMISSTION.LIST);
                }
                // if (this.state.isEdit) {
                //   window.history.back();
                // } else {
                //   this.props.history.push(slug.FACILITY_PERMIT.LIST);
                // }
              }}
              style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
              icon={IconNames.CIRCLE_ARROW_LEFT}
              iconSize={Icon.SIZE_LARGE}
              intent={Intent.SUCCESS}
            />
            {/* </Link> */}
            {this.props.focusFacility && (
              <react.Fragment>
                <Permissions allowed={[`facilityEmission.write`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Link
                      to={
                        slug.FACILITY_EMISSTION.EDIT_WITH_ID +
                        this.state._idObject
                      }
                    >
                      <Icon
                        style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                        icon={IconNames.MANUALLY_ENTERED_DATA}
                        iconSize={Icon.SIZE_LARGE}
                        intent={Intent.PRIMARY}
                      />
                    </Link>
                  </React.Fragment>
                </Permissions>
                <Permissions allowed={[`facilityEmission.delete`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Icon
                      style={{ cursor: 'pointer' }}
                      icon={IconNames.BAN_CIRCLE}
                      iconSize={Icon.SIZE_LARGE}
                      intent={Intent.DANGER}
                      onClick={this.handelDelete}
                    />
                  </React.Fragment>
                </Permissions>
              </react.Fragment>
            )}
          </div>
        </HeaderContainer>
        <Clearfix height={16} />
        <DisplayField
          isRequiredField={true}
          label='Tên cơ sở/dự án'
          value={this.getInitialValue('facility.FacilityNameFull')}
        />
        <Clearfix height={12} />
        <DisplayField
          isRequiredField
          label='Loại chất thải'
          value={this.getInitialValue('emissionType.Name')}
        />
        <Clearfix height={12} />

        <DisplayField
          isRequiredField
          label='Giá trị'
          value={this.getInitialValue('DataValue')}
        />
        <Clearfix height={12} />

        <DisplayField
          label='Người quản lý'
          value={this.getInitialValue('Manager')}
        />
        <Clearfix height={12} />

        <DisplayField
          label='Bằng cấp người quản lý'
          value={this.getInitialValue('Degree')}
        />
        <Clearfix height={12} />
        <DisplayField
          label='Hình thức quản lý'
          value={this.getInitialValue('ManagementType')}
        />
        <Clearfix height={12} />
        <DisplayField
          label='Đường dẫn (URL)'
          value={
            <a href={`${this.getInitialValue('url')}`} target='_blank'>
              <NameContainer>{this.getInitialValue('url')}</NameContainer>
            </a>
          }
        />
        <Clearfix height={12} />
        <DisplayField
          label='Nguồn trích dẫn'
          value={this.getInitialValue('reference')}
        />
        <Clearfix height={12} />
        <DisplayField
          label='Ghi chú'
          value={this.getInitialValue('Description')}
        />
        <Clearfix height={12} />
        <DisplayField
          label='Thêm vào'
          value={
            this.getInitialDateValue('AddedOn') +
            ' bởi ' +
            this.getInitialValue('AddedBy')
          }
        />
        <Clearfix height={12} />
        <DisplayField
          label='Cập nhật lần cuối'
          value={`${this.getInitialValue('UpdatedOn', '', 'date_1')}${this.getInitialValue('UpdatedBy', '')
            ? ` bởi ${this.getInitialValue('UpdatedBy', '')}`
            : ''
            }`}
        />
      </div>
    );
  }
}

export default withRouter(FacilitypemissionView);



// WEBPACK FOOTER //
// ./src/containers/FacilityemissionContainer/FacilityemissionView/index.js